// extracted by mini-css-extract-plugin
export var menuIcon = "_sz-0";
export var menuIconInline = "_sz-1";